define([
	"dojo/_base/declare",
	"SiteAdmin/DataSheetItemActual"
], function(declare,DataSheetItemActual) {

	return declare(DataSheetItemActual, {
		getNodeDisplayName: function(/*Context*/ctx, /*Node*/node) {
			// summary: return name of referenced node
			if (node.$Type == "SubRoutingRevision") {
				// Need DependencyPath on the view definition xml to able get the parent SubRouting node
				node = ctx.cache.getNode(node.__Parent__);
			}

			return this.inherited(arguments, [ctx, node]);
		}
	});
});